document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('savings-calculator');
  if (!root) return;

  const spendInput = root.querySelector('[data-sc-spend]');
  const freightInput = root.querySelector('[data-sc-freight]');
  const calcBtn = root.querySelector('[data-sc-calculate]');
  if (!spendInput || !freightInput || !calcBtn) return;

  const priceCell = root.querySelector('[data-amount="price"]');
  const volumeCell = root.querySelector('[data-amount="volume"]');
  const freightCell = root.querySelector('[data-amount="freight"]');
  const opportunityCell = root.querySelector('[data-amount="opportunity"]');
  const totalCell = root.querySelector('[data-sc-total]');
  const tableWrapper = root.querySelector('[data-sc-table-wrap]');
  const overlay = tableWrapper?.querySelector('[data-sc-overlay]');

  const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

  function attachCurrencyFormatter(input) {
    input.addEventListener('blur', () => {
      const val = parseFloat((input.value || '').replace(/[^0-9.-]/g, ''));
      input.value = isNaN(val) ? '' : fmt.format(val);
    });
    input.addEventListener('focus', () => {
      const val = parseFloat((input.value || '').replace(/[^0-9.-]/g, ''));
      input.value = isNaN(val) ? '' : String(val);
    });
  }

  attachCurrencyFormatter(spendInput);
  attachCurrencyFormatter(freightInput);

  function computeSavings(spend, freight) {
    const priceSavings = spend * 0.05;
    const volumeSavings = spend * (1 - 1 / 1.1);
    const freightSavings = freight;
    const opportunitySavings = spend * 0.1 * 0.3;
    const total = priceSavings + volumeSavings + freightSavings + opportunitySavings;
    return { priceSavings, volumeSavings, freightSavings, opportunitySavings, total };
  }

  function renderPlaceholders() {
    [priceCell, volumeCell, freightCell, opportunityCell, totalCell].forEach((el) => {
      if (el) el.textContent = '--';
    });
  }

  function renderSavings({ priceSavings, volumeSavings, freightSavings, opportunitySavings, total }) {
    if (priceCell) priceCell.textContent = fmt.format(priceSavings);
    if (volumeCell) volumeCell.textContent = fmt.format(volumeSavings);
    if (freightCell) freightCell.textContent = fmt.format(freightSavings);
    if (opportunityCell) opportunityCell.textContent = fmt.format(opportunitySavings);
    if (totalCell) totalCell.textContent = fmt.format(total);
  }

  function setLoading(isLoading) {
    if (!tableWrapper) return;
    tableWrapper.classList.toggle('is-loading', isLoading);
    if (overlay) overlay.setAttribute('aria-hidden', String(!isLoading));
    calcBtn.disabled = isLoading;
    const label = calcBtn.querySelector('.button-label') || calcBtn;
    label.textContent = isLoading ? 'Calculating…' : 'Calculate';
  }

  renderPlaceholders();

  calcBtn.addEventListener('click', () => {
    const spend = parseFloat((spendInput.value || '').replace(/[^0-9.-]/g, '')) || 0;
    const freight = parseFloat((freightInput.value || '').replace(/[^0-9.-]/g, '')) || 0;

    setLoading(true);
    renderPlaceholders();

    const delay = Math.floor(Math.random() * (3500 - 1000 + 1)) + 1000;

    setTimeout(() => {
      renderSavings(computeSavings(spend, freight));
      if (spend) spendInput.value = fmt.format(spend);
      if (freight) freightInput.value = fmt.format(freight);
      setLoading(false);
    }, delay);
  });
});
